import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Account } from '@accounts/models/account';
import { AccountPermissions } from '@accounts/models/account-permissions';
import { ENVIRONMENT } from '@env/environment';

@Injectable()
export class MyProfileService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiUrl = `${ENVIRONMENT.coreApi.endpoint}/account`;

  update(account: Account): Observable<Account> {
    return this.#httpClient.put<Account>(
      `${this.#apiUrl}/editMyAccount`,
      account
    );
  }

  getAccountPermissions(): Observable<AccountPermissions> {
    return this.#httpClient.get<AccountPermissions>(
      `${this.#apiUrl}/myPermissions`
    );
  }
}
